import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import { AsFieldResultsSection, AsOversizeCorrectionDataSection, AsResultsSection } from '../Sections';

let LabWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const OversizeCorrectionApplies = useSelector(
    pipe(createWorksheetSelector!('OversizeCorrectionData.OversizeCorrectionApplies'), valueOrDefault(false))
  ) as boolean;

  return (
    <>
      <PageSection heading="Field Results">
        <NamePrefixModifier appendNamePrefix="FieldResults">
          <AsFieldResultsSection />
        </NamePrefixModifier>
      </PageSection>
      {OversizeCorrectionApplies && (
        <PageSection heading="Oversize Correction Data">
          <AsOversizeCorrectionDataSection />
        </PageSection>
      )}
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <AsResultsSection />
      </WorksheetResultsSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

const AsRelativeCompactionLabWorksheet = withInjectedProps(LabWorksheet);

export { AsRelativeCompactionLabWorksheet };
export default AsRelativeCompactionLabWorksheet;
